<h1 mat-dialog-title>{{'INFORT.TITULO' | translate}}</h1>
<mat-dialog-content>
  <ng-container *ngIf="sinIdiomas">
    <div class="w100" fxLayout="row" fxLayoutAlign="space-around center">
      <button mat-fab color="primary">
        <mat-icon>priority_high</mat-icon>
      </button>
      <h1>{{'INFORT.SINLANGS' | translate}}</h1>
    </div>
  </ng-container>
  <mat-tab-group *ngIf="!sinIdiomas">
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="mr-20">playlist_add_check</mat-icon>
        {{'INFORT.PASOS.PASO_1' | translate}}
      </ng-template>
      <mat-list>
        <ng-container *ngFor="let paso of pasos; let last = last;">
          <mat-list-item class="hta">
            <div fxLayout="row" fxLayoutAlign="space-between center" class="w70" [@animate]="{value:'*',params:{delay:paso.delay, y:'25px'}}">
              <h2>{{'INFORT.LISTAPASOS.' + paso.clave | translate}}</h2>
              <div fxLayout="column" fxLayoutAlign="start center" class="status">
                <ng-container *ngIf="paso.cargando; else pasoCargado">
                  <mat-spinner diameter="40" class="m-20"></mat-spinner>
                </ng-container>
                <ng-template #pasoCargado>
                  <button mat-mini-fab [ngClass]="{'undone':!paso.completo, 'done':paso.completo}">
                    <mat-icon *ngIf="!paso.completo">more_horiz</mat-icon>
                    <mat-icon *ngIf="paso.completo">done</mat-icon>
                  </button>
                  <p>
                    <em *ngIf="!paso.completo">{{'INFORT.STATUS.PEND' | translate}}</em>
                    <b *ngIf="paso.completo"><em>{{'INFORT.STATUS.DONE' | translate}}</em></b>
                  </p>
                </ng-template>
              </div>
            </div>
          </mat-list-item>
          <mat-divider *ngIf="!last"></mat-divider>
        </ng-container>
      </mat-list>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="mr-20">list</mat-icon>
        {{'INFORT.PASOS.PASO_2' | translate}}
      </ng-template>
      <div class="w100" fxLayout="column" fxLayoutAlign="start stretch">
        <ng-container *ngFor="let pregunta of cuestionario; let last = last;">
          <p [innerHTML]="pregunta.question" class="fw500"></p>
          <ng-container *ngIf="pregunta.typeQuestion==1">
            <mat-form-field appearance="outline" >
              <mat-label>{{'INFORT.RESP' | translate}}</mat-label>
              <textarea  matInput [disabled]="true" [(ngModel)]="pregunta.answersSelected[0].answer"></textarea>
              <mat-error>{{'INFORT.NORESP' | translate}}</mat-error>
            </mat-form-field>
          </ng-container>
          <ng-container *ngIf="pregunta.typeQuestion==2">
            <div fxLayout="row" fxLayoutAlign="star center">
                    <mat-radio-group  [(ngModel)]="pregunta.answersSelected[0].answer" [disabled]="true">
                        <mat-radio-button  color="warn" *ngFor="let opciones of pregunta.answers;" [value]="opciones.idAnswer.toString()" fxLayout="column">
                            <span >{{opciones.answers}}</span>
                        </mat-radio-button>
                    </mat-radio-group>
                </div>
          </ng-container>
          <mat-divider *ngIf="!last"></mat-divider>
        </ng-container>
      </div>
    </mat-tab>

    <mat-tab *ngIf="verHistorial">
      <ng-template mat-tab-label>
        <mat-icon class="mr-20">history</mat-icon>
        {{'INFORT.PASOS.PASO_3' | translate}}
      </ng-template>
      <div class="w100" fxLayout="column" fxLayoutAlign="start stretch">
      </div>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button (click)="cerrar()">{{'DESCARGAR_ENCUESTA.MODAL.BTNCLOSE' | translate}}</button>
</mat-dialog-actions>
